if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.productId = this.form.dataset.productId;
        this.addCartType = this.form.dataset.addCartType;
        this.crossSellActive = this.form.dataset.crossSellActive;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.crossSellProducts = cross_sell_data[this.productId];
        this.relatedProducts = related_product_data[this.productId];

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            this.setAddToCartGAData(formData);
            const crossSellPopup = document.querySelector('cross-sell-popup');
            const quickAddModal = this.closest('quick-add-modal');
            if (window.showCrossSellPopup && !this.crossSellShownCookie() && crossSellPopup){
              const sourceProduct = {
                sku: this.sku,
                productName: this.productName,
                variantName: this.variantName,
                price: this.price,
                compare_at_price: this.compare_at_price,
                crossSellActive: this.crossSellActive,

              }
              crossSellPopup.open(response, this.relatedProducts, sourceProduct, this.crossSellProducts);
            } else if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      crossSellShownCookie() {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
          let [cookieName, cookieValue] = cookie.trim().split('=');
          if (cookieName === "cross_sell_shown") return true;
        }
        return false;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      setAddToCartGAData(formData){
        //Get Add to Cart Data
        this.variantId = formData.get('id');
        this.quantity = formData.get('quantity');
        const selectIDElement = this.form.querySelector('select[name="id"]');
        if (selectIDElement){
          const selectedItemEl = selectIDElement.querySelector('option:checked');
          if (selectedItemEl){
            this.sku = selectedItemEl.dataset.sku;
            this.productName = selectedItemEl.dataset.productName;
            this.variantName = selectedItemEl.dataset.variantName;
          } else {
            this.sku = '';
            this.productName = '';
            this.variantName = '';
          }
        } else {
          //single item with hidden input
          const itemIDElement = this.form.querySelector('input[name="id"]');
          if(itemIDElement){
            this.sku = itemIDElement.dataset.sku;
            this.productName = itemIDElement.dataset.productName;
            this.variantName = itemIDElement.dataset.variantName;
          } else {
            this.sku = '';
            this.productName = '';
            this.variantName = '';
          }
        }
        const priceElement = this.form.querySelector('.variant__price');
        if (priceElement){
          const priceRaw = priceElement.innerHTML;
          this.price = priceRaw.replace("$", "");
        } else {
          this.price = 0;
        }
        const comparePriceElement = this.form.querySelector('.variant__compare__price');
        if (comparePriceElement){
          const comparePriceRaw = comparePriceElement.innerHTML;
          this.compare_at_price = comparePriceRaw.replace("$", "");
        } else {
          this.compare_at_price = 0;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
